import { render, staticRenderFns } from "./UsersCreatePage.vue?vue&type=template&id=819ee840&"
import script from "./UsersCreatePage.vue?vue&type=script&lang=js&"
export * from "./UsersCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports